/* eslint import/prefer-default-export:off */
import fnFilterAndSortRelatedPosts from './filterAndSortRelatedPosts';

export const filterAndSortRelatedPosts = fnFilterAndSortRelatedPosts;
